import styled from 'styled-components';

export const Butterfly = styled.div``;
